"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = EmailOutline;

var _EmailOutline = require("@adobe/react-spectrum-workflow/dist/EmailOutline");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function EmailOutline(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_EmailOutline.A4uEmailOutline, null));
}